import { ContractActionType } from "../action-types/ContractActionType";

const initialState = {
  contractInfo: {
    contractAddress: "",
    contractName: "",
    contractChain: "",
    contractNetwork: 2,
    contractSupportedChains: {
      2: false,
      3: false,
      4: false,
    },
  },

  programDuration: {
    value: 0,
    loading: false,
  },
  totalFeesCollected: {
    value: 0,
    loading: false,
  },
  feesDeducted: {
    value: 0,
    loading: false,
  },
  maxDafi: {
    value: 0,
    loading: false,
  },
  distPoolBalance: {
    value: 0,
    loading: false,
  },
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case ContractActionType.SET_CONTRACT_INFO:
      return {
        ...state,
        contractInfo: action.payload,
      };

    case ContractActionType.SET_PROGRAM_DURATION:
      return {
        ...state,
        programDuration: action.payload,
      };

    case ContractActionType.SET_TOTAL_FEES_COLLECTED:
      return {
        ...state,
        totalFeesCollected: action.payload,
      };

    case ContractActionType.SET_FEES_DEDUCTED:
      return {
        ...state,
        feesDeducted: action.payload,
      };

    case ContractActionType.SET_DIST_POOL_BALANCE:
      return {
        ...state,
        distPoolBalance: action.payload,
      };

    case ContractActionType.SET_MAX_DAFI:
      return {
        ...state,
        maxDafi: action.payload,
      };

    case ContractActionType.RESET_CONTRACT_DATA:
      return initialState;

    default:
      return state;
  }
};

export default reducer;
